import { render, staticRenderFns } from "./ProfessionDropdown.vue?vue&type=template&id=491a9834&scoped=true&"
import script from "./ProfessionDropdown.vue?vue&type=script&lang=js&"
export * from "./ProfessionDropdown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "491a9834",
  null
  
)

export default component.exports